import { ReactNode, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
	children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
	const { pathname } = useLocation();

	// Cada sección es una ruta, pero la página entera hace scroll en la ventana, que no se entera
	// de que ha cambiado de ruta: sin esto se aterriza a la altura a la que se dejó la anterior.
	// Solo el `pathname`: las pestañas de Simuladores viajan en `?tab=` y no deben saltar.
	// `useLayoutEffect` y no `useEffect`: sube antes de pintar; si no, la sección nueva se ve un
	// fotograma a la altura de la anterior y luego salta.
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return (
		<>
			{/* <Header /> */}
			{children}
			{/* <Footer /> */}
		</>
	);
};

export default Layout;
